import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskInProgress = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 11,
			height: 11,
			rx: 5.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 11,
			height: 11,
			rx: 5.5,
			stroke: "#53647E",
			strokeOpacity: .18
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 9C6.79565 9 7.55871 8.68393 8.12132 8.12132C8.68393 7.55871 9 6.79565 9 6C9 5.20435 8.68393 4.44129 8.12132 3.87868C7.55871 3.31607 6.79565 3 6 3V3.9C6.55696 3.9 7.0911 4.12125 7.48492 4.51508C7.87875 4.9089 8.1 5.44305 8.1 6C8.1 6.55695 7.87875 7.0911 7.48492 7.48492C7.0911 7.87875 6.55695 8.1 6 8.1L6 9Z",
			fill: "#515D71"
		})
	]
});
export default SvgTaskInProgress;
